import { PlusIcon } from '../../../assets/Plus';
import { Button } from '../../../components/ui/button';

import { useTelegramBackButton } from '../../../utils/BackButton';
import { impactOccuer } from '../../../utils/hapticEvents';
import { useGetAddresses } from '../services/getAddresses';

import { t } from 'i18next';
import { UserAddressList } from '../../../components/UserAddressList';
import { cn } from '../../../lib/utils';
import { useNavigate } from 'react-router-dom';

export const Addresses = () => {
  useTelegramBackButton('/profile');
  const navigate = useNavigate();
  const { addresses } = useGetAddresses();

  const handleAddAddress = () => {
    impactOccuer('soft');
    navigate('/adding-address');
  };

  return (
    <div className="flex flex-col relative px-4 pt-4 pb-2">
      <p className="text-display-sm text-center pb-4">{t('addresses')}</p>

      <div className="space-y-4 pb-32">
        {addresses.length > 0 ? (
          <UserAddressList addresses={addresses} />
        ) : (
          <div className="flex items-center justify-center px-1 py-20">
            <p className="text-text-tertiary text-caption-sm-medium">
              {t('empty-addresses')}
            </p>
          </div>
        )}
      </div>

      {/* Fixed button */}
      <div className="fixed bottom-safe-bottom left-0 right-0 px-4">
        <Button
          className={cn(
            'h-12 flex flex-row items-center justify-center rounded-xl w-full shadow-none',
            {
              'bg-button-secondary text-text-primary': addresses.length > 0,
              'bg-button-primary': addresses.length === 0,
            }
          )}
          onClick={handleAddAddress}
        >
          <PlusIcon
            className={cn('', {
              'text-text-primary': addresses.length > 0,
              'text-text-white': addresses.length === 0,
            })}
          />
          <p className="text-body-base-semibold ml-2">{t('new-address')}</p>
        </Button>
      </div>
    </div>
  );
};

export default Addresses;
